export default {
  GuideInCard: 'guide-in-card-component',
  GuideInCardWithoutButton: 'guide-without-button-component',
  GuideBasic: 'guide-basic-component',
  GuideWithImage: 'guide-with-image-component',
};
